module.exports = __webpack_public_path__ + "img/upload_doc.4fbb35f7.svg";